import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"สัญญาก่อนสมรส (Prenup) — Bilingual ระหว่างคู่สมรสไทย-ต่างชาติ","metaTitle":"สัญญาก่อนสมรส Prenup ไทย-อังกฤษ — บังคับใช้ในไทย | NYC","metaDesc":"ร่างสัญญาก่อนสมรส (Prenuptial Agreement) ไทย-อังกฤษ บังคับใช้ตามประมวลกฎหมายแพ่งและพาณิชย์ มาตรา 1465-1466 พร้อมโนตารีและบันทึกเข้าทะเบียนสมรสให้"},"en":{"h1":"Prenuptial Agreement — Bilingual Thai-English for Cross-Border Couples","metaTitle":"Thai Prenuptial Agreement — Bilingual, Notarised, Registered | NYC","metaDesc":"Thai-English prenuptial agreements enforceable under Thai Civil & Commercial Code s.1465-1466. Notarisation included plus registration at the Amphur."}} as const;

export const Route = createFileRoute("/marriage/prenup")({
  head: () => {
    const url = `${SEO_SITE}/marriage/prenup`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/marriage/prenup", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/marriage/prenup", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/marriage/prenup", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/marriage/prenup", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/marriage/prenup", "/en/marriage/prenup")],
    };
  },
  component: () => <SubServicePage slug="marriage/prenup" locale="th" />,
});
